import { render, staticRenderFns } from "./MultipleImgUploadComponent.vue?vue&type=template&id=27a9d050&"
import script from "./MultipleImgUploadComponent.vue?vue&type=script&lang=js&"
export * from "./MultipleImgUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports